import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")

  return (_openBlock(), _createBlock("div", {
    class: ["number-buttons", {light: _ctx.lightTheme}]
  }, [
    _createVNode("button", {
      class: "number-buttons__button btn-stripped",
      type: "button",
      disabled: _ctx.disableDecrease || _ctx.disabled,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setValue(_ctx.modelValue - 1)))
    }, [
      _createVNode(_component_InlineSvgScoped, {
        src: require('@/assets/images/icons/icon-less.svg'),
        "aria-label": "icon-less"
      }, null, 8, ["src"])
    ], 8, ["disabled"]),
    _withDirectives(_createVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue = $event)),
      class: "number-buttons__input",
      tabindex: "-1"
    }, null, 512), [
      [_vModelText, _ctx.modelValue]
    ]),
    _createVNode("button", {
      class: "number-buttons__button btn-stripped",
      type: "button",
      disabled: _ctx.disableIncrease || _ctx.disabled,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setValue(_ctx.modelValue + 1)))
    }, [
      _createVNode(_component_InlineSvgScoped, {
        src: require('@/assets/images/icons/icon-add.svg'),
        "aria-label": "icon-add"
      }, null, 8, ["src"])
    ], 8, ["disabled"])
  ], 2))
}